import { FetchService, actionObject, calculateTotalSize, shouldPollForTranscode, showDialog, showModal, sleep, } from '@/utils';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import {
  createMemoryActionG,
  deleteMemoryActionG,
  hidePopup,
  openModal,
  paginateMemoryAction,
  paginateMemoryActionAsync,
  removeMemory,
  setMemoryTypesAsync,
  showPopup,
  updateMemoryActionG,
} from '../actions';
import { UPDATE_USER_DATA_ASYNC } from '../auth/action-types';
import { SET_CRITERIAS_ASYNC } from '../home/action-types';
import { authSelector, memorySelector, StoragePopupSelector } from '../selectors';
import {
  APPROVE_MEMORY,
  APPROVE_MEMORY_ASYNC,
  CREATE_MEMORY,
  CREATE_MEMORY_ASYNC,
  DELETE_MEMORY,
  DELETE_MEMORY_ASYNC,
  GET_MEMORIES,
  GET_MEMORIES_ASYNC,
  PAGINATE_BUBBLES,
  SET_MEDIA_TYPE,
  SET_MEDIA_TYPE_TRIGGER,
  SET_STEP_CREATE_MEMORY,
  SET_STEP_CREATE_MEMORY_TRIGGER,
  TOGGLE_PIN_MEMORY,
  TOGGLE_PIN_MEMORY_ASYNC,
  UPDATE_MEMORY,
  UPDATE_MEMORY_ASYNC,
  VIEW_MEMORY,
} from './action-types';
import { GET_STORAGE_LOG } from '../storageLog/action-types';
import { GET_NOTIFICATIONS } from '../notifications/action-types';

function* setCreateMemoryStep({ payload }: any) {
  yield put(actionObject(SET_STEP_CREATE_MEMORY_TRIGGER, payload));
}

function* setMediaType({ payload }: any) {
  yield put(actionObject(SET_MEDIA_TYPE_TRIGGER, payload));
}

function* createMemory({ payload }: any): any {
  try {
    const { user } = yield select(authSelector);
    const storagePopup = yield select(StoragePopupSelector);

    const { router, mediaFiles, isPending = false, onCreated, onError, ...filteredPayload } = payload;

    const response = yield call(FetchService, 'memory', 'POST', { ...filteredPayload, isPending }, user?.token);

    yield put(actionObject(CREATE_MEMORY_ASYNC, response?.result));
    yield put(createMemoryActionG(response?.result));

    // give component the id


    // existing logic...
    if (response?.result?.id && !isPending) {
      let delayMs = 1600;
      for (let i = 0; i < 15; i++) {
        const status = yield call(FetchService, `memory/status/${response?.result?.id}`, 'GET', {}, user?.token);
        if (status?.result?.cv === 'ready') break;
        yield call(sleep, delayMs);
        delayMs = Math.min(Math.floor(delayMs), 20000);
      }
    }
    if (typeof onCreated === 'function') {
      try { onCreated(response?.result); } catch { }

    }

    if (!isPending) {
      router?.push(`/app/story/${payload?.storyId}`);
    }

    // return response?.result;

  } catch (error: any) {
    if (typeof payload?.onError === 'function') {
      try { payload.onError(error); } catch { }
    }
    // existing error handling...
    let message = error?.message;
    if (error?.message?.includes('error')) message = JSON.parse(message)?.error;
    yield call(showModal, message, 'SHOW_MODAL');
  }
}



function* updateMemoryAsync({ payload }: any): any {
  try {
    const { user } = yield select(authSelector);
    const storagePopup = yield select(StoragePopupSelector);

    const { router, mediaFiles, isPending = false, ...rest } = payload;

    let totalSize = 0;
    if (Array.isArray(rest.mediaFiles)) {
      rest.mediaFiles.forEach((f: any) => { if (f?.size) totalSize += f.size; });
    }
    if (rest.media?.size) totalSize += rest.media.size;
    if (Array.isArray(rest.complementaryMedia)) {
      rest.complementaryMedia.forEach((f: any) => { if (f?.size) totalSize += f.size; });
    }

    const payloadMemory = { ...rest, isPending, totalSize };

    const response = yield call(
      FetchService,
      `memory/${payloadMemory?.story_id}/${payloadMemory?.id}`,
      'PUT',
      payloadMemory,
      user?.token
    );

    const updated = response?.result?.updatedMemory;
    yield put(actionObject(UPDATE_MEMORY_ASYNC, updated));

    const needsPoll = updated?.id && shouldPollForTranscode(updated, payload);
    if (needsPoll) {
      let delayMs = 1600;
      const maxDelay = 20000;
      const maxAttempts = 15;

      for (let i = 0; i < maxAttempts; i++) {
        const status = yield call(FetchService, `memory/status/${updated.id}`, 'GET', {}, user?.token);
        if (status?.result?.cv === 'ready') break;
        yield call(sleep, delayMs);
        delayMs = Math.min(Math.floor(delayMs * 1.6), maxDelay);
      }
    }

    // NEW: only navigate if NOT pending

    router?.push(`/app/story/${payload?.storyId}`);
    // 

    if (updated?.usedStoragePercentage >= 80 && !storagePopup) {
      yield put(openModal({ content: 'You have used 80% of available storage space.' }));
      yield put(hidePopup());
    } else if (updated?.usedStoragePercentage < 80 && storagePopup) {
      yield put(showPopup());
    }
    return updated
  } catch (error: any) {
    let message = error?.message;
    if (typeof message === 'string' && message.includes('error')) {
      try { message = JSON.parse(message)?.error; } catch { }
    }
    yield put(openModal({ content: message || 'Update failed' }));
  }
}




function* togglePinMemoryAsync({ payload }: any): any {
  try {
    const { user } = yield select(authSelector);

    const response = yield call(
      FetchService,
      `memory/pin/${payload?.story_id}/${payload?.id}`,
      'PUT',
      { isPinned: payload.isPinned },
      user?.token
    );
    yield put(actionObject(TOGGLE_PIN_MEMORY_ASYNC, response?.result?.updatedMemory));
    yield put(updateMemoryActionG(response?.result?.updatedMemory));
    yield put(openModal({ content: response?.result?.message }));
  } catch (error: any) {
    let message = error?.message;
    if (error?.message?.includes('error')) {
      message = JSON.parse(message)?.error;
    }
    yield put(openModal({ content: message }));
  }
}


function* approveUpdateMemoryAsync({ payload }: any): any {
  try {
    const { user } = yield select(authSelector);

    const response = yield call(
      FetchService,
      `memory/approval/${payload?.id}/${payload?.story_id}`,
      'PUT',
      {},
      user?.token,
    );

    yield put(actionObject(APPROVE_MEMORY_ASYNC, response?.result?.updatedMemory));
    yield call(showDialog, response?.result?.message, 'success');
  } catch (error: any) {
    let message = error?.message;
    if (error?.message?.includes('error')) message = JSON.parse(message)?.error;
    yield call(showDialog, message, 'error');
  }
}
function* getMemoriesStory({ payload }: any): any {
  try {
    const { user } = yield select(authSelector);

    const publicAccess =
      payload?.publicAccess === true ||
      payload?.invitation === true ||
      payload?.invitation === 'true' ||
      !user?.token;

    const { result } = yield call(
      FetchService,
      `memory/${payload?.story_id}?publicAccess=${publicAccess}`,
      'POST',
      payload?.query,
      user?.token,
    );
    const memories = [...(result || [])];
    yield put(actionObject(GET_MEMORIES_ASYNC, memories));
    yield put(
      actionObject(SET_CRITERIAS_ASYNC, {
        criterias: payload?.query || { search: '', prompts: [], collaborators: [] },
        result: [],
      }),
    );
  } catch (error: any) {
    let message = error?.message;
    if (error?.message?.includes('error')) message = JSON.parse(message)?.error;
    yield call(showDialog, message, 'error');
  }
}

function* deleteMemoryAsync({ payload, callback }: ReturnType<typeof removeMemory>): any {
  try {
    const { user } = yield select(authSelector);
    const { result } = yield call(
      FetchService,
      `memory/${payload?.story_id}/${payload?.id}`,
      'DELETE',
      {},
      user?.token,
    );

    if (callback) {
      callback({
        ok: true,
      });
    }
    yield put(actionObject(DELETE_MEMORY_ASYNC, payload?.id));
    yield put(actionObject(GET_STORAGE_LOG, user?.id));
    yield put(deleteMemoryActionG(result?.memory));
    yield put(actionObject(GET_NOTIFICATIONS))

  } catch (error: any) {
    let message = error?.message;
    if (error?.message?.includes('error')) message = JSON.parse(message)?.error;
    yield call(showDialog, message, 'error');
    if (callback) {
      callback({
        ok: false,
        message,
      });
    }
  }
}

function* viewMemoryAsync({ payload }: any): any {
  try {
    const { user } = yield select(authSelector);
    const { result } = yield call(FetchService, `memory/view/${payload}`, 'GET', {}, user?.token);
    yield put(actionObject(UPDATE_USER_DATA_ASYNC, { ...user, ...result }));
  } catch (error: any) {
    let message = error?.message;
    console.error(message)
  }
}

function* paginateBubbles({ payload, callback }: ReturnType<typeof paginateMemoryAction>) {
  try {
    const { criterias } = payload;
    const { user } = yield select(authSelector);
    const paramObj = {
      ...(payload.page ? { page: String(payload.page) } : {}),
      ...(payload.limit ? { limit: String(payload.limit) } : {}),
      ...criterias,
    };
    const { result } = yield call(FetchService, `memory/bubbles/${payload?.storyId}`, 'POST', paramObj, user?.token);
    const { memoriesLoaded = [] }: { memoriesLoaded: { id: string;[key: string]: unknown }[] } = yield select(
      memorySelector,
    );
    const updatedData = updateAndMerge(memoriesLoaded, result.data);
    yield put(paginateMemoryActionAsync(updatedData));
    yield put(setMemoryTypesAsync(result?.filters || []));
    if (callback) {
      callback({
        ok: true,
        data: result,
      });
    }
  } catch (error: any) {
    let message = error?.message;
    if (callback) {
      callback({
        ok: false,
        message,
      });
    }
  }
}

function updateAndMerge<T extends { id: string;[key: string]: unknown }>(oldData: T[], newData: T[]) {
  const dataMap = new Map(oldData.map((item) => [item.id, item]));
  newData.forEach((item) => dataMap.set(item.id, item));
  return [...dataMap.values()];
}
export function* watchSetCreateMemoryStep() {
  yield takeLatest(SET_STEP_CREATE_MEMORY, setCreateMemoryStep);
}

export function* watchSetMediaType() {
  yield takeLatest(SET_MEDIA_TYPE, setMediaType);
}

export function* watchCreateMemory() {
  yield takeLatest(CREATE_MEMORY, createMemory);
}

export function* watchGetMemoriesStory() {
  yield takeLatest(GET_MEMORIES, getMemoriesStory);
}

export function* watchDeleteMemory() {
  yield takeLatest(DELETE_MEMORY, deleteMemoryAsync);
}

export function* watchUpdateMemory() {
  yield takeLatest(UPDATE_MEMORY, updateMemoryAsync);
}
export function* watchTogglePinMemory() {
  yield takeLatest(TOGGLE_PIN_MEMORY, togglePinMemoryAsync)
}

export function* watchApproveUpdateMemory() {
  yield takeLatest(APPROVE_MEMORY, approveUpdateMemoryAsync);
}

export function* watchViewMemory() {
  yield takeLatest(VIEW_MEMORY, viewMemoryAsync);
}

export function* watchPaginateBubbles() {
  yield takeLatest(PAGINATE_BUBBLES, paginateBubbles);
}
